import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Applicant } from '../../Shared/Types/applicantTypes';



export const applicantsApi = createGenericApiSlice<Applicant>({
	reducerPath: "applicantsApi",
	tag: TagTypes.Applicant,
	endpoint: "applicants",
});

export const {
	useGetAllQuery: useGetApplicantsQuery,
	useGetByIdQuery: useGetApplicantByIdQuery,
	useCreateMutation: useCreateApplicantMutation,
	useUpdateMutation: useUpdateApplicantMutation,
	useDeleteMutation: useDeleteApplicantMutation,
} = applicantsApi;
